<template>
  <b-card no-body class="p-2">
    <b-row class="h-100 d-flex">
      <b-col
        md="7"
        cols="12"
        class="d-flex px-0 pb-0 overflow-hidden position-relative"
        style="
          background: #1b1b24 0% 0% no-repeat padding-box;
          border: 1px solid #202626;
          border-radius: 10px;
        "
      >
        <div v-if="loading" class="w-100 h-100 p-3">
          <b-skeleton height="100%" width="100%"> </b-skeleton>
        </div>
        <div class="w-100 d-flex flex-column align-items-center" v-else>
          <div
            class="position-absolute h-100 w-100 bg-remain-secondary d-flex left-0 justify-content-center align-items-start"
            v-if="competition.verify_status == 'CANCELED'"
            style="z-index: 2; backdrop-filter: blur(4px)"
          >
            <h4 class="bg-remain-danger w-100 rounded text-center py-75 m-50">
              Canceled
            </h4>
          </div>
          <div
            class="d-flex w-100 align-items-center justify-content-between position-absolute top-0 left-0 text-white"
            :class="[`bg-remain-${calRemaining(competition).status}`]"
            v-if="competition.verify_status !== 'CANCELED'"
          >
            <div
              :class="`p-75 px-50   bg-remain-${
                competition.verify_status == 'PENDING'
                  ? 'warning'
                  : competition.verify_status == 'ACCEPTED'
                  ? 'success'
                  : competition.verify_status == 'REJECTED'
                  ? 'danger'
                  : 'warning'
              }`"
              style="border-radius: 0px 0px 19px 0px"
            >
              <small>
                {{
                  competition.verify_status == "PENDING"
                    ? "Pending"
                    : competition.verify_status == "ACCEPTED"
                    ? "Accepted"
                    : competition.verify_status == "REJECTED"
                    ? "Rejected"
                    : "Pending"
                }}
              </small>
            </div>
            <div class="py-75 px-1">
              <small v-if="calRemaining(competition).status === 'yellow'">
                Register starts at
                <span
                  v-if="
                    calRemaining(competition).status === 'yellow'
                      ? (date = calRemaining(competition).time)
                      : ''
                  "
                >
                  {{ date }}
                </span>
              </small>
              <small v-if="calRemaining(competition).status === 'warning'">
                Register will end at
                <span
                  v-if="
                    calRemaining(competition).status === 'warning'
                      ? (date = calRemaining(competition).time)
                      : ''
                  "
                >
                  {{ date }}</span
                >
              </small>
              <small v-if="calRemaining(competition).status === 'success'">
                Register is ended and competition started at
                <span
                  v-if="
                    calRemaining(competition).status === 'success'
                      ? (date = calRemaining(competition).time)
                      : ''
                  "
                >
                  {{ date }}</span
                >
              </small>
              <small v-if="calRemaining(competition).status === 'danger'">
                The competition is over!
                <span
                  v-if="
                    calRemaining(competition).status === 'danger'
                      ? (date = calRemaining(competition).time)
                      : ''
                  "
                >
                  {{ date }}</span
                >
              </small>
            </div>
          </div>
          <div class="d-flex align-items-center h-100">
            <b-img
              :src="competition.thumbnail || errorImage"
              fluid
              @error="setAltImg"
              :alt="competition.name"
              class="w-100"
              style="max-height: 300px"
            />
          </div>
          <div class="d-flex justify-content-between flex-wrap mt-auto">
            <div @click.stop class="w-100 d-flex align-items-center">
              <b-button
                v-if="userData && userData.type == 'admin'"
                class="my-50 hover-warning"
                @click="$emit('showChangeStatusModal', competition)"
              >
                <feather-icon icon="RepeatIcon" size="12" />
                <span class="small"> Change status </span>
              </b-button>
              <b-button
                v-if="
                  userData &&
                  userData.type == 'partner' &&
                  competition.award_type === 'absolute'
                "
                class="mb-1 small hover-danger"
                @click="$emit('showPayModal', competition)"
              >
                <feather-icon icon="DollarSignIcon" size="12" />
                <span class="small"> Ready to pay </span>
              </b-button>
            </div>
          </div>
        </div>
      </b-col>
      <b-col md="5" cols="12" class="d-flex flex-column">
        <template v-if="loading">
          <b-skeleton height="40px" width="40%"> </b-skeleton>
          <div class="d-flex align-items-center justify-content-between">
            <b-skeleton height="30px" width="40%"> </b-skeleton>
            <b-skeleton height="30px" width="40%"> </b-skeleton>
          </div>
          <b-skeleton height="25px" width="100%"> </b-skeleton>
          <b-skeleton height="25px" width="100%"> </b-skeleton>
          <b-skeleton height="25px" width="100%"> </b-skeleton>
          <b-skeleton height="25px" width="100%"> </b-skeleton>
          <b-skeleton height="25px" width="100%"> </b-skeleton>
          <div
            class="d-flex align-items-center justify-content-between mt-auto"
          >
            <b-skeleton height="30px" width="35%"> </b-skeleton>
            <b-skeleton height="30px" width="35%"> </b-skeleton>
            <b-skeleton height="30px" width="15%"> </b-skeleton>
          </div>
        </template>
        <template v-else>
          <div class="d-flex align-items-center justify-content-between">
            <div>
              <div class="d-flex align-items-center mb-1">
                <div
                  class="bg-warning rounded-lg mr-50"
                  style="width: 5px; height: 14px"
                ></div>
                <p class="text-white mb-0">
                  {{ competition.name }}
                </p>
              </div>
              <div class="mb-1">
                <b-link class="text-primary text-lighten-2"
                  ><span
                    class="nowrap-white-space"
                    v-for="(broker, index) in competition.brokers.data"
                    :key="index"
                    >{{ broker.name
                    }}<span
                      v-if="competition.brokers.data.length !== index + 1"
                    >
                      ,
                    </span></span
                  ></b-link
                >
              </div>
            </div>
          </div>
          <!-- <div
            class="mt-1 d-flex align-items-end justify-content-between flex-wrap"
          >
            <div class="w-100 py-25" v-if="calRemaining(competition).title">
              <small
                ><span class="text-info text-lighten-2">{{
                  calRemaining(competition).title
                }}</span>
                remaining :
                <span class="text-warning">{{
                  calRemaining(competition).remain
                }}</span></small
              >
              <b-progress
                v-if="
                  calRemaining(competition).title ==
                  'Registration end and Competition begin'
                "
                :value="calRemaining(competition).rate"
                :max="calRemaining(competition).total"
                height="8px"
                class="progress-bar-warning my-50"
                variant="warning"
              />
            </div>
          </div> -->
          <div
            v-if="calRemaining(competition).status === 'danger'"
            class="mb-1"
          >
            <small>Open for registration - </small
            ><small
              :class="competition.active ? 'text-success' : 'text-danger'"
              >{{ competition.active ? "active" : "not active" }}</small
            >
          </div>
          <div class="mb-1 text-justify">
            <small
              v-for="(condition, index) in competition.conditions"
              :key="index"
            >
              {{ condition }}
            </small>
          </div>
          <div class="mb-1">
            <small class="font-weight-bolder"
              >Number of price places:
              {{ competition.awards.length || "-" }}</small
            >
          </div>
          <div class="mb-1">
            <small class="font-weight-bolder"
              >Maximum number of participants:
              {{ competition.max_participant_value }}</small
            >
          </div>
          <div class="mb-1">
            <small>Registration fee:</small>
            <span class="text-danger ml-50 h4 mb-0 font-weight-bold"
              >${{ competition.fee }}</span
            >
          </div>
          <b-badge
            class="bg-danger mb-1 wrap-white-space"
            v-if="
              userData.type !== 'partner' &&
              !competition.bought &&
              !competition.available_to_register &&
              calRemaining(competition).status === 'warning'
            "
          >
            Registation capacity is full
          </b-badge>
          <b-badge
            class="bg-info mb-1 wrap-white-space"
            v-if="competition.bought"
          >
            You already have registered the competition
          </b-badge>
          <div class="d-flex align-items-center flex-wrap mt-auto">
            <b-button
              class="px-lg-3 mr-50 gradient-btn mt-1"
              @click="$emit('register')"
              v-if="
                userData.type !== 'partner' &&
                !competition.bought &&
                competition.available_to_register &&
                calRemaining(competition).status === 'warning'
              "
            >
              Register
            </b-button>
            <b-button
              v-ripple.400="'rgba(186, 191, 199, 0.15)'"
              variant="secondary bg-lighten-1"
              class="px-lg-3 mr-50 mt-1"
              @click="$emit('rulesShow')"
            >
              Rules
            </b-button>
            <b-button
              @click="$emit('showShareButtons')"
              v-ripple.400="'rgba(113, 102, 240, 0.15)'"
              variant="secondary bg-lighten-1"
              class="btn-icon mr-50 mt-1"
            >
              <feather-icon icon="Share2Icon" />
            </b-button>
          </div>
        </template>
      </b-col>
    </b-row>
  </b-card>
</template>

<script>
import {
  BCard,
  BRow,
  BCol,
  BImg,
  BLink,
  BButton,
  BProgress,
  BSkeleton,
  BBadge,
} from "bootstrap-vue";
import Ripple from "vue-ripple-directive";
// let moment = require("jalali-moment");

export default {
  computed: {
    userData() {
      return (
        this.$store.state.auth.userData ||
        JSON.parse(localStorage.getItem("userData"))
      );
    },
  },
  components: {
    BCard,
    BRow,
    BCol,
    BImg,
    BLink,
    BProgress,
    BButton,
    BSkeleton,
    BBadge,
  },
  directives: {
    Ripple,
  },
  props: {
    competition: {
      type: Object,
      default: () => {},
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style scoped></style>
